import { createContext, useContext } from 'react';

export const DevtoolsContext = createContext({ enabled: false });

export function useDevtools() {
    return useContext(DevtoolsContext);
}
